import { createNode, PlainDateTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainDateTime } from '../../utils/temporal';

export const ParseDateTime = createNode({
    id: 'Parse DateTime',
    name: 'Parse DateTime',
    description: 'Parses a DateTime from an ISO 8601 string (e.g. "2024-03-15T14:30:00")',
    aiDescription:
        'Takes an ISO 8601 datetime string (e.g. "2024-03-15T14:30:00") on the "Text" port and outputs a parsed DateTime on the "DateTime" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Text: { kind: 'string' },
    },
    outPorts: {
        DateTime: PlainDateTimeDataType,
    },
    execute: function (input) {
        const dateTime = Temporal.PlainDateTime.from(input.inPorts.Text);
        return { output: { DateTime: fromPlainDateTime(dateTime) } };
    },
});
